import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import type { ImageField as TImageField } from "src/components/Form/Form.types.ts";
import { DropZoneInput } from "src/components/DropZoneInput/DropZoneInput.tsx";
import { FileTypes } from "src/common/constants.ts";

export const ImageField = ({
  name,
  field,
  disabled,
}: {
  name: string;
  field: TImageField;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  const form = useFormContext();
  return (
    <Controller
      key={name}
      control={form.control}
      name={name}
      render={({ field: { onChange, value, name }, formState }) => (
        <DropZoneInput
          disabled={disabled}
          value={value}
          validationRules={{
            accept: [FileTypes.AnyImage],
          }}
          helperText={field.helperText}
          error={formState.errors.root?.[name]?.message}
          onUpload={onChange}
        />
      )}
    />
  );
};
